import { TreeNode } from 'primeng/api';
import { formatQuantity } from '../shared/pipes/format-quantity.pipe';

export class p2p_shift_node {
    patientId!: string;
    normMedDescription!: string;
    p2pMedId!: string;
    locationGrouping!: string;
    locationGroupingValue!: string;
    adminId!: string;
    adminName!: string;
    uom!: string;
    adminDateTime!: string;
    transType!: string;
    children!: any[];
    adminGroupingValue!: string;
    normAdminType!: string;
    interactionCount!: string;
    adminFlagCount: any;
    shiftDate!: string;
    shiftDisplayDate?: string;
    patientCount!: string;
    shiftworked!: string;
    transactionsVolume!: string;
    index!: number;

    static fromJSON(object: any) {
      const shiftNode = new p2p_shift_node();
        shiftNode.children = object['children'];
        shiftNode.patientId = object.mrnNum;
        shiftNode.normMedDescription = object.medDesc;
        shiftNode.p2pMedId = object.p2pMedId
        shiftNode.adminId = object.adminId;
        shiftNode.locationGrouping = object.locationGrouping;
        shiftNode.locationGroupingValue = object.locationGroupingValue;
        try{
          shiftNode.adminFlagCount = formatQuantity(Math.abs(object.adminFlagCount));
          shiftNode.transactionsVolume = formatQuantity(Math.abs(object.transactionsVolume));
        }
        catch {
          shiftNode.adminFlagCount = '0'
          shiftNode.transactionsVolume = '0'
        }
        // shiftNode.interactionCount = object.interactionCount
        shiftNode.uom = object.uom;
        shiftNode.shiftDate = object.shiftDate;
        if (object.shiftDisplayDate != null) {
          shiftNode.shiftDisplayDate = object.shiftDisplayDate;
        }
        shiftNode.transType = object.transactionType;
        shiftNode.adminGroupingValue = object.adminGroupingValue;
        if (object.transactionType != 'Med Use'){
          shiftNode.interactionCount = Math.abs(object.totalDoseage).toString()
        }
        else{
          shiftNode.interactionCount = object.interactionsCount.toString()
        }
        if (object.patientCount){
        shiftNode.patientCount = object.patientCount.toString();}
        if (object.adminDateTime){
          shiftNode.adminDateTime = object.adminDateTime}
        if (object.patientId){
          shiftNode.patientId = object.patientId}
        try{
          shiftNode.index = object.index}
        catch{
          shiftNode.index = 0
        }

        shiftNode.shiftworked = object.shiftworked;
        
        return shiftNode;
      }

      static toTreeNode(shiftNode: p2p_shift_node): TreeNode {
        return ({ data: Object.assign({}, shiftNode), children: [{ data: { label: "Shift Data" }, children: [{}] }], leaf: true, expanded: false, parent: null } as unknown) as TreeNode
      }
}
